<template>
  <div class="bordered" :class="{ disabled: !vulnerability.enabled, deleting: vulnerability.deleting, resetting: vulnerability.resetting }">

    <div class="container-fill" @click="toggle">
      <div>
        {{ vulnerability.title }}
        <span class="term" v-for="term in vulnerability.terms_and" :key="term"> AND {{term}}</span>
        <span class="term" v-for="term in vulnerability.terms_not" :key="term"> NOT {{term}}</span>
      </div>
      <div v-show="vulnerability.alert_limit">
        Alert limit:{{ vulnerability.alert_limit }}
      </div>
      <div v-show="vulnerability.document_limit">
        Document limit:{{ vulnerability.document_limit }}
      </div>

      {{ vulnerability.created.substring(0,10) }} {{ vulnerability.created.substring(11,19) }}
    </div>

    <div class="details" v-show="isActive">
      <div class="details-header">
        <div class="item">
          <b> Description: </b>
          {{ vulnerability.description }}
          <br>
          <b> Remediation: </b>
          {{ vulnerability.remediation }}
        </div>        
      </div>
    </div>

    <pre class="debug" v-show="debugMode">{{ vulnerability }}</pre>
  
  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#keywordInfo {
  display: inline-block;
  margin-right: 5px;
}
#keywordButtons {
  display: inline-block;
  float: right;
}
.keyword-info {
  display: inline-block;
  margin-right: 5px;
}
.container {
  display: flex;
}
.container-fill {
  display: flex;
  justify-content: space-between;
}
.term {
  font-size: small;
}
.item {
  margin: 10px;
}
.disabled {
  background-color: lightgrey;
}
.deleting {
  background-color: lightcoral;
}
.resetting {
  background-color: lightyellow;
}
.details {
  margin-top: 5px;
  border-top: 1px solid #cccccc;
  padding-top: 5px;
}
.details-header {
  font-size: small;
}
.details-header > h2,h3,h4 {
  font-size: initial;
  margin: 0px;
}
</style>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    vulnerability: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState([
      'debugMode',
      'apiAccount'
    ])
  },
  data () {
    return {
      isActive: false,
      newAndTerm: '',
      newNotTerm: ''
    }
  },
  methods: {
    toggle: function (event) {
      if (event.target.tagName == 'BUTTON' || event.target.tagName == 'INPUT') return
      this.isActive = !this.isActive
    }
    // toggleKeyword () {
    //   this.apiAccount.put('/keywords/' + this.keyword.id, {enabled: !this.keyword.enabled}).then(keyword => {
    //     this.keyword.enabled = keyword.enabled
    //   })
    // }
  }
}
</script>
